function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import { tns } from "tiny-slider/src/tiny-slider";

/*------------------------------------------------------------------
Sliders
------------------------------------------------------------------*/
var CustomSlider = /*#__PURE__*/function () {
  function CustomSlider(group) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, CustomSlider);
    this.group = group;
    this.active = true;
    this.info = this.group.querySelectorAll('.js-slider--info') || false;
    this.dots = this.group.querySelectorAll('.js-slider--dots') || false;
    this.controller = false;
    this.timeout = null;
    this.buttons = {
      prev: this.group.querySelectorAll('.js-slider--button[data-direction="prev"]') || false,
      next: this.group.querySelectorAll('.js-slider--button[data-direction="next"]') || false
    };

    // Save the custom page buttons here
    this.pageButtons = [];
    this.settings = {
      nav: false,
      loop: false,
      rewind: true,
      controls: false
    };
    for (var key in options) this.settings[key] = options[key];
    var _loop = function _loop(_key) {
      if (_this.buttons[_key]) {
        for (var index = 0; index < _this.buttons[_key].length; index++) {
          var button = _this.buttons[_key][index];
          button.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.controller) _this.controller.goTo("".concat(_key));
          });
        }
      }
    };
    for (var _key in this.buttons) {
      _loop(_key);
    }
    this.reinit();
  }
  _createClass(CustomSlider, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.settings.container = this.group.querySelector('.js-slider') || false;
      if (this.settings.container) {
        this.controller = tns(this.settings);
        try {
          var info = this.controller.getInfo();

          // If we cant even make a slider, remove all the controls
          if (info.slideCount <= 1) {
            [this.buttons.prev, this.buttons.next, this.info, this.dots].forEach(function (items) {
              if (items) {
                for (var index = 0; index < items.length; index++) {
                  // Find the parent
                  var parent = items[index].parentNode;
                  // Remove the control item
                  parent.removeChild(items[index]);
                  // Remove the parent if it is empty
                  if (parent.children.length == 0) parent.parentNode.removeChild(parent);
                }
              }
            });
          }

          // Create some custom dots
          if (this.dots) {
            for (var index = 0; index < this.dots.length; index++) {
              var dots = this.dots[index];
              var _loop2 = function _loop2() {
                // Save the index
                var index = i + 1;
                // Create a new button
                var button = document.createElement('button');

                // Git the button a class
                button.className = 'js-slider--page-button';

                // Give the button an event handler
                button.addEventListener('click', function (e) {
                  e.preventDefault();
                  _this2.controller.goTo(index - 1);
                });

                // Save the button in the pageButtons array
                _this2.pageButtons.push({
                  element: button,
                  index: index
                });

                // Put the button in the dots container
                dots.appendChild(button);
              };
              for (var i = 0; i < info.slideCount; i++) {
                _loop2();
              }
            }
          }

          // Call the update method
          this.update(info);
        } catch (err) {
          console.log(err);
        }
      }
    }
  }, {
    key: "update",
    value: function update(data) {
      var _this3 = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        // Update the info text
        if (_this3.info) {
          for (var index = 0; index < _this3.info.length; index++) {
            var info = _this3.info[index];
            info.innerHTML = '';
            var spans = {
              1: document.createElement('span'),
              2: document.createElement('span'),
              3: document.createElement('span')
            };
            spans[1].innerHTML = data.displayIndex <= 9 ? "0".concat(data.displayIndex) : data.displayIndex;
            spans[2].innerHTML = ' / ';
            spans[3].innerHTML = data.slideCount <= 9 ? "0".concat(data.slideCount) : data.slideCount;
            info.appendChild(spans[1]);
            info.appendChild(spans[2]);
            info.appendChild(spans[3]);
          }
        }

        // Update the active state of the page buttons
        _this3.pageButtons.forEach(function (button) {
          data.displayIndex == button.index ? button.element.classList.add('active') : button.element.classList.remove('active');
        });
      }, 100);
    }
  }, {
    key: "reinit",
    value: function reinit() {
      var _this4 = this;
      this.init();
      // If we have a slider controller
      if (this.controller) this.controller.events.on('indexChanged', function (data) {
        return _this4.update(data);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.controller) this.controller.destroy();
    }
  }]);
  return CustomSlider;
}();
export { CustomSlider as default };